import log from '@/services/log';
import Icons from '@/icons'
import ctx from '@/services/ctx';
import * as sr from '@/services/storiesonboardrepository'
import config from '@/services/config';
import '@/assets/styles/pages/auth.less';

class AuthModule implements IBoardButtonsProvider, ICardButtonsProvider {

    public getBoardButtons = async (t: ITrelloClient, opts:any) : Promise<Array<any>> => {
        var self = this;
        var buttons = [];
        try {
            var hasAccess = await sr.checkAccess(t);
            var isSetupCompleted = await config(t).getSetupIsCompleted();
            if(!hasAccess && isSetupCompleted) {
                var btn = {
                    icon: {
                        dark: Icons.AppIcon,
                        light: Icons.AppIcon,
                    },
                    text: "StoriesOnBoard",
                    callback: function(t2) {
                        t2.popup(self.getAuthPopupConfig());
                    },
                    condition: 'always'
                    };
                buttons.push(<never>btn);
            }
        }
        catch(e) {
            log.err(e)
        }

        return buttons;
    }



    public getCardButtons(t: ITrelloClient, opts: any): Promise<any[]> {
        var self = this;
        return new Promise(resolve => {
            ctx(t).get().then(ctx => {
                var buttons = [];
                if (ctx.isSetupCompleted && !ctx.isUserAuthenticated) {
                    var btn = {
                        icon: Icons.AppIcon,
                        text: "StoriesOnBoard",
                        callback: function(t2) {
                            t2.popup(self.getAuthPopupConfig());
                        },
                        condition: 'always'
                        };
                    buttons.push(<never>btn);
                    resolve(buttons);
                }
                else {
                    resolve([]);
                }
            }).catch(err => log.err(err))
        });
    }


    private getAuthPopupConfig() { 
        return {
            url: '../views/auth.html',
            callback: (a) => {},
            height: 160,
            title: "Authorize StoriesOnBoard"
        };
    }
}

export var authModule = new AuthModule();
export default authModule;
